import { c as _c } from "react/compiler-runtime";
import { AddIcon } from '@systemeio/ui/icons';
import { Modal, PrimaryButton, RadioGroup, RadioGroupDataInterface, SecondaryButton, Tooltip } from '@systemeio/ui';
import { EventTypeEnum, eventChooseTypeLocoKeys } from 'modules/calendar/events/enums/event-type-enum';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EventCreateModalProps {
  limitReached?: boolean;
  isFetchingEventLimit: boolean;
}
export const EventCreateModal = t0 => {
  const $ = _c(58);
  const {
    isFetchingEventLimit,
    limitReached
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const [opened, setOpened] = useState(false);
  const [eventType, setEventType] = useState(EventTypeEnum.Individual);
  let t1;
  if ($[0] !== t) {
    t1 = t(eventChooseTypeLocoKeys[EventTypeEnum.Individual]);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: EventTypeEnum.Individual,
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(eventChooseTypeLocoKeys[EventTypeEnum.Group]);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: EventTypeEnum.Group,
      caption: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = [t2, t4];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const eventTypeData = t5;
  const t6 = !limitReached;
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.calendar.event_limit_tooltip");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(true);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <AddIcon />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("dashboard.calendar.create_new_event");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <span className="hidden sm:flex">{t10}</span>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isFetchingEventLimit || $[20] !== limitReached || $[21] !== t11) {
    t12 = <PrimaryButton onClick={t8} isFetching={isFetchingEventLimit} disabled={limitReached}>{t9}{t11}</PrimaryButton>;
    $[19] = isFetchingEventLimit;
    $[20] = limitReached;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t6 || $[25] !== t7) {
    t13 = <Tooltip disabled={t6} mode="hover" label={t7}>{t12}</Tooltip>;
    $[23] = t12;
    $[24] = t6;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.calendar.choose_event_type");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setOpened(false);
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = value => setEventType(value);
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== eventType || $[32] !== eventTypeData) {
    t17 = <RadioGroup optionsWrapperClassName="flex-col items-start" selected={eventType} options={eventTypeData} onChange={t16} />;
    $[31] = eventType;
    $[32] = eventTypeData;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setOpened(false);
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t) {
    t19 = t("confirmation_modal.cancel");
    $[35] = t;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19) {
    t20 = <SecondaryButton width="large" onClick={t18}>{t19}</SecondaryButton>;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== eventType || $[40] !== router) {
    t21 = () => {
      router.push(`/calendar/create?eventType=${eventType}`);
    };
    $[39] = eventType;
    $[40] = router;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t) {
    t22 = t("confirmation_modal.confirm");
    $[42] = t;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t21 || $[45] !== t22) {
    t23 = <PrimaryButton width="large" onClick={t21}>{t22}</PrimaryButton>;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t20 || $[48] !== t23) {
    t24 = <div className="mt-4 flex justify-end gap-4">{t20}{t23}</div>;
    $[47] = t20;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== opened || $[51] !== t14 || $[52] !== t17 || $[53] !== t24) {
    t25 = <Modal title={t14} opened={opened} onClose={t15}>{t17}{t24}</Modal>;
    $[50] = opened;
    $[51] = t14;
    $[52] = t17;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t13 || $[56] !== t25) {
    t26 = <>{t13}{t25}</>;
    $[55] = t13;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  return t26;
};